(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const threshold = Number(document.body.dataset.freeShippingThreshold) || 5000;
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const titles = {
    '4-in-1-electric-pet-grooming-kit-hair-trimmer-clippers-nail-grinder-for-cats-dogs': 'The Complete Grooming Set',
    'dog-paw-cleaner': 'The Paw Cleansing Cup',
    'cat-tree-for-large-cats-cat-tower-for-indoor': 'The Sculptural Cat Tower',
    'cat-litter-trapping-mat': 'The Litter Catch Mat',
    'trunk-pet-mat-car-travel-dog-mat-car-seat-car-trunk-pet-mat': 'The Tailored Travel Mat',
    'natural-catnip-cat-wall-stick-on-ball-toy-scratchers-treats-healthy-natural-removes-balls-to-promote-digestion-cat-grass-snack': 'The Catnip Wall Toy'
  };

  const shell = $('[data-cart-shell]');
  const cartLines = $('[data-cart-lines]');
  const cartFooter = $('[data-cart-footer]');
  const cartNudge = $('.cart-nudge');

  function progressCopy(total, count) {
    if (!count) return `Free delivery starts at ${money(threshold)}.`;
    const remaining = Math.max(0, threshold - total);
    return remaining ? `${money(remaining)} to complimentary delivery` : 'Complimentary delivery unlocked';
  }

  function lineMarkup(item) {
    const title = titles[item.handle] || item.product_title;
    const image = item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x$1$2')}" alt="">` : '';
    return `<article class="cart-line">${image}<div><h3>${title}</h3><p>${money(item.final_price)}</p><div class="cart-line__quantity"><button type="button" data-change-key="${item.key}" data-quantity="${item.quantity - 1}" aria-label="Remove one">−</button><span>${item.quantity}</span><button type="button" data-change-key="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Add one">＋</button></div></div></article>`;
  }

  function syncCart(cart) {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const progress = Math.min(100, cart.total_price / threshold * 100);
    $$('[data-cart-progress-copy]').forEach((node) => { node.textContent = progressCopy(cart.total_price, cart.item_count); });
    $$('[data-cart-progress-bar]').forEach((node) => { node.style.width = `${progress}%`; });
    const total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (cartLines) cartLines.innerHTML = cart.item_count ? cart.items.map(lineMarkup).join('') : '<div class="cart-empty"><h3>Your bag is quiet.</h3><p>Choose what belongs in your routine.</p></div>';
    if (cartFooter) cartFooter.hidden = !cart.item_count;
    if (cartNudge) cartNudge.hidden = !cart.item_count || !shell?.hidden;
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    syncCart(cart);
    return cart;
  }

  async function addItems(ids) {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
    });
    await getCart(); openCart();
  }

  function openCart() {
    if (!shell) return;
    shell.hidden = false; document.body.classList.add('drawer-open');
    if (cartNudge) cartNudge.hidden = true;
    $('[data-cart-close]', shell)?.focus();
  }
  function closeCart() {
    if (!shell) return;
    shell.hidden = true; document.body.classList.remove('drawer-open');
    getCart();
  }

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { event.preventDefault(); await getCart(); openCart(); return; }
    const close = event.target.closest('[data-cart-close]');
    if (close) { closeCart(); return; }
    const add = event.target.closest('[data-add-variant]');
    if (add) { event.preventDefault(); add.disabled = true; try { await addItems([add.dataset.addVariant]); } finally { add.disabled = false; } return; }
    const bundle = event.target.closest('[data-bundle-variants]');
    if (bundle) { bundle.disabled = true; try { await addItems(bundle.dataset.bundleVariants.split(',')); } finally { bundle.disabled = false; } return; }
    const change = event.target.closest('[data-change-key]');
    if (change) { change.disabled = true; await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: change.dataset.changeKey, quantity: Number(change.dataset.quantity) }) }); await getCart(); return; }
    const tab = event.target.closest('[data-set-tab]');
    if (tab) { $$('[data-set-tab]').forEach((item) => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); }); $$('[data-set-panel]').forEach((panel) => { panel.hidden = panel.dataset.setPanel !== tab.dataset.setTab; }); return; }
    const menu = event.target.closest('[data-menu-toggle]');
    if (menu) { const nav = $('[data-mobile-nav]'); const openState = nav.hidden; nav.hidden = !openState; menu.setAttribute('aria-expanded', String(openState)); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const id = data.get('id'); const quantity = Number(data.get('quantity') || 1);
    const ids = Array.from({ length: quantity }, () => id);
    await addItems(ids);
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && shell && !shell.hidden) closeCart(); });
  getCart().catch(() => {});
})();
